export default __webpack_public_path__ + "7d30a2d2878fa139359a7d0e62a4fbeb.svg";